import InputTypesEnum from '../../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../../Helpers/ValidityHelper';
import InvoiceAutomationService from '../../../../Services/InvoiceAutomationService';
import InvoiceAutomationItem from '../../../../Domain/ThirdParty/Project/InvoiceAutomationItem';
import { getOtherProjectOptions, getSetupToSave } from '../../../../Helpers/invoiceAutomationEditorHelper';

// The other projects on the invoice of a project's automatic invoicing, in a small window of their own that the
// invoice card's "Combine with another project" opens: the client's projects whose ready jobs go on the setup's drafts
// too. Like the invoice's edit window, it saves the whole setup, so the rest of it stays as it is.
export default class InvoiceAutomationProjectsWindowDescription {
  static titleForEdit = (setup) => `Projects On This Invoice – ${setup.ProjectName}`;
  static get itemType() {
    return InvoiceAutomationItem;
  }
  static messageOnSuccess = 'Automatic invoicing has been saved.';
  static serviceFunction = (setup) => InvoiceAutomationService.UpsertInvoiceAutomation(getSetupToSave(setup));

  static pagesInGeneralEditWizzard = [
    {
      label: 'Projects',
      fields: [
        {
          fieldName: 'OtherProjectIds',
          label: 'Other Projects On This Invoice',
          tooltipText:
            "Only the client's projects without automatic invoicing of their own, and on no other project's invoice, are listed.",
          className: 'col-12',
          type: InputTypesEnum.MultiChoice,
          validityChecker: ValidityHelper.AlwaysFlawless,
          selectvalues: getOtherProjectOptions,
          info: "Their ready jobs go on this project's drafts with its own, by the same month rule and from the same first month.",
        },
      ],
    },
  ];
}
